module.exports = __webpack_public_path__ + "static/video-journal-e78d335901d853348ed449a8ffc89f7f.png";